const translation = {
  1033: 'Inventário',
  1034: 'Loja',
  1530: 'Você já tem uma assinatura',
  1531: 'Tem certeza de que deseja comprar uma assinatura?',
  1532: "Custará <img src='/svgs/dominion.svg' style='margin: 0px 10px -10px 10px'/> {{ param1 }}?",
  1533: "Abra uma <span style='color: #FF9326;font-size: 28px'>LOJA PESSOAL</span> </br>para a sua estrutura de jogadores",
  1534: "Alugar por <img src='/svgs/loyaltyIcon.svg' style='margin: 0px 0px -5px 2px; width: 20px'/> {{ param1 }} Loyalty Coin?",
  1535: 'Tem certeza de que deseja alugar o Hexatile #{{ param1 }}?',
  1536: "Custará <img src='/svgs/loyaltyIcon.svg' style='margin: 0px 0px -3px 2px'/> {{ param1 }} Loyalty Coin",
  1537: 'O aluguel será debitado a cada 30 dias',
  1538: 'Tem certeza de que deseja selecionar este Conselheiro?',
  1539: "O serviço <span style='color: #FF9326'>Territory X</span> <span style='color: #FF9326'>NÃO</span> se aplica às áreas alugadas.",
  1540: 'Você escolheu alugar {{ param1 }} Hexatiles',
  1541: 'Necessário para o aluguel',
  1542: '2 anos',
  1543: 'O Hexatile #{{ param1 }} está alugado',
  1544: 'Você pode vê-lo no mapa no domínio 2 do Conselheiro',
  1545: 'Tem certeza de que deseja selecionar este Conselheiro?',
  1546: 'O serviço Territory X NÃO se aplica às áreas alugadas.',
  1547: 'Tem certeza de que deseja colocar um Orbe em um Hexatile alugado?',
  1548: 'Se o aluguel terminar, o orbe deixará de pertencer a você.',
  1549: '({{ param1 }} alugados)',
  1550: 'Hexatiles alugados',
  1551: 'Tem certeza de que deseja mover / vender o último Hexatile?',
  1552: 'Se não restar nenhum Hexatile neste Conselheiro, ele entrará em HIBERNAÇÃO. Pode ficar vazio por 7 dias, depois será destruído.',
  1553: 'Não há um único Hexatile (alugado ou comprado) neste Conselheiro.',
  1554: 'Ele pode ficar vazio em estado de hibernação por 7 dias, depois será destruído.',
  1555: 'Preencha o Conselheiro com Hexatiles (compre ou alugue) para tirá-lo da hibernação.',
  1556: 'Você pode obter Loyalty Coin entrando no Masters of Game todos os dias e completando missões (em breve)',
  1557: 'Loyalty Coin é uma moeda especial destinada ao aluguel de lotes de terra em Legends Of Interaction. A moeda só pode ser usada por um Master of Game. Você pode obter Loyalty Coin entrando no Masters of Game todos os dias e completando missões (em breve)',
  1558: '{{ param1 }} ficou vazio e entrou em HIBERNAÇÃO por 7 dias.',
  1559: ' Preencha-o com Hexatiles (compre ou alugue), ou ele será destruído.',
  1560: 'Não há um único Hexatile (alugado ou comprado) neste Conselheiro.',
  1561: 'Ele pode ficar vazio em estado de hibernação por 7 dias, depois será destruído.',
  1562: 'Preencha o Conselheiro com Hexatiles (compre ou alugue) para tirá-lo da hibernação.',
  1563: 'Bem-vindo ao <br/> MASTERS OF GAME',
  1564: "Recompensas do <span style='color: #FF9326'>DIA {{ param1 }}</span> :",
  1565: "Recompensas da <span style='color: #FF9326'>SEMANA</span> :",
  1566: "Recompensas do <span style='color: #FF9326'>MÊS</span> :",
  1567: "<span style='color: #FF9326'>{{ param1 }}</span> Hexatiles <br/> movidos com sucesso.",
  1568: "Você pode vê-lo no mapa no domínio <span style='color: #FF9326'>{{ param2 }}</span>.",
  1569: 'Não ativado',
  1570: 'Tem certeza de que deseja ativar / atualizar o Territory X?',
  1571: 'Tem certeza de que deseja cancelar esta compra?',
  1572: "Esta ação encerrará o leilão e as informações do hexatile voltarão para a aba «<span style='color: #FF9326'>World</span>»",
  1573: 'Sim, quero cancelar a compra',
  1574: 'Não, voltar aos lances',
  1575: 'Você só pode ver e colocar Orbes com ZOOM 19 ou mais.',
  1576: "Por favor, <span style='color: #FF9326'>amplie</span> o mapa.",
  1577: 'Os Orbes só podem ser colocados em Hexatiles comprados.',
  1578: 'Selecione um Hexatile que pertença a você.',
  1579: 'Suas ordens de VENDA serão removidas automaticamente após 10 dias se não houver ofertas de compra.',
  1580: 'Veja no mapa para ver os detalhes.',
  1581: 'Restam {{ param1 }} dias',
  1582: 'Sua ordem de VENDA será removida automaticamente após 10 dias se não houver ofertas de compra',
  1583: "O Hexatile #{{ param1 }} foi vendido por <img src='/svgs/reex.svg' style='margin: 0px 5px -10px 3px'/> {{ param2 }}",
  1584: 'Esta oportunidade está disponível apenas para participantes do grupo focal. <br/> Se tiver interesse, entre em contato com a pessoa que o convidou para cá.',
  1585: 'Códigos de indicação:',
  1586: 'Os códigos são atualizados automaticamente após a ativação.',
  1587: 'Indisponível',
  1600: 'Disponível: {{param1}}',
  1601: 'Clique para colocar',
  1602: 'Amplie até o nível {{param1}} para colocar um minerador',
  1603: 'Ainda não há mineradores',
  1604: 'Minerador',
  1605: 'Disponível para coletar',
  1606: 'Total coletado',
  1607: 'Última coleta',
  1608: 'O minerador está cheio e parou. Colete os REEX para que ele continue minerando',
  1609: 'Clique para coletar',
  1610: 'Ainda não há nada para coletar',
  1611: 'Meus mestres',
  1612: 'Minha loja',
  1613: 'LOI Referral',
  1614: 'Modelos',
  1615: 'Criar',
  1616: 'Pré-visualização',
  1617: 'Assinatura',
  1618: 'É necessária assinatura de loja',
  1619: 'Para ter uma loja é necessária uma assinatura ativa de formador de mercado.',
  1620: 'Ir para a assinatura',
  1621: 'Ainda não há modelos',
  1622: 'Crie o primeiro',
  1623: 'É assim que os compradores veem a sua loja',
  1624: 'Nenhum modelo está à venda — os compradores veem uma loja vazia',
  1625: 'Assinatura da loja',
  1626: 'A assinatura está ativa',
  1627: 'Sem assinatura',
  1628: 'Válida até {{param1}}',
  1629: 'Renovar ou comprar',
  1630: 'Comprar',
  1631: '1 ano',
  1632: '2 anos',
  1633: '3 anos',
  1634: '99 anos',
  1635: 'Comprar a assinatura «{{param1}}» por {{param2}} {{param3}}?',
  1636: 'O pagamento da assinatura estará disponível em breve',
  1637: 'À venda: {{param1}}',
  1638: 'Não está à venda',
  1639: '{{param1}} itens',
  1640: 'Descrição',
  1641: 'Preço',
  1642: 'À venda: {{param1}}',
  1643: 'Não está à venda',
  1644: 'Conteúdo do modelo ({{param1}})',
  1645: 'O pacote está vazio.',
  1646: 'Excluir',
  1647: 'Preço (Reex)',
  1648: 'À venda',
  1649: 'Salvar',
  1650: 'Retirar da venda',
  1651: 'Criar um modelo',
  1652: 'Orbes',
  1653: 'Moedas',
  1654: 'Aqui está vazio',
  1655: 'Imagem do modelo',
  1656: 'Enviar imagem',
  1657: 'Alterar imagem',
  1658: 'Nome do modelo',
  1659: 'No modelo ({{param1}})',
  1660: 'Cancelar',
  1661: 'Criando...',
  1662: 'Demais',
  1663: 'Ainda não há ofertas',
  1664: 'Compra indisponível',
  1665: 'Você é um formador de mercado.',
  1666: 'Restam: {{param1}}',
  1667: 'Vendedor',
  1668: 'Preço por pacote',
  1669: 'Conteúdo do pacote ({{param1}})',
  1670: 'Não há dados sobre o conteúdo.',
  1671: 'Quantidade',
  1672: 'Total',
  1673: 'Pré-visualização — compra indisponível',
  1674: 'Comprado: {{param1}} ×{{param2}}',
  1675: 'Comprar «{{param1}}» ×{{param2}} por {{param3}} Reex?',
  1676: 'Entradas:',
  1677: 'Quantidade (± à venda)',
  1678: 'Adicionar à venda',
  1679: 'Colocar à venda',
  1680: 'Recompensa coletada',
  1681: 'Coletado: {{param1}} REEX',
  1682: 'De',
  1683: 'Até',
  1684: 'Mostrar',
  1685: 'Exportar CSV',
  1686: 'Recurso',
  1687: 'Transações',
  1688: 'Relatório',
  1689: '{{param1}} ano',
  1690: '{{param1}} anos',
  1691: 'O prazo será somado à sua data de validade atual.',
  1692: 'Após esta compra você se tornará um formador de mercado e sairá da sua estrutura atual.',
  1693: 'Comprar Dominion',
  1694: 'QUANTIDADE',
  1695: 'MOEDA DE PAGAMENTO',
  1696: 'Em breve',
  1697: 'Saldo: {{param1}}',
  1698: 'Criptomoeda',
  1699: 'Rede {{param1}}',
  1700: 'Total:',
  1701: '{{param1}} INSUFICIENTE',
  1702: 'COMPRAR {{param1}} {{param2}}',
  1703: 'Taxa: {{param1}} REEX por 1 {{param2}}. Outros métodos de pagamento serão adicionados mais tarde.',
  1704: 'Comprado {{param1}} {{param2}}',
  1705: 'Comprar {{param1}} {{param2}} por {{param3}}?',
  1706: 'Ofertas pessoais',
  1707: 'Um preço especial para certa quantidade de pacotes destinado a um jogador específico da sua estrutura. As ofertas pessoais são aplicadas antes do preço normal e desaparecem quando se esgotam.',
  1708: 'Jogador',
  1709: 'Não há ofertas pessoais para este modelo',
  1710: 'Adicionar',
  1711: 'Remover a oferta pessoal para {{param1}}?',
  1712: 'Preço pessoal',
  1713: 'Preço pessoal para os primeiros {{param1}} pacotes',
  1714: '{{param1}} pelo preço pessoal, {{param2}} pelo preço normal',
  1715: 'Venda',
  1716: 'Jogador #{{param1}}',
  1717: 'Pessoais: {{param1}}',
  1718: 'Carregando a taxa…',
  1719: 'Não foi possível carregar a taxa de câmbio. A compra está temporariamente indisponível.',
  1720: 'Tentar novamente',
  1721: 'TAXA INDISPONÍVEL',
  1722: 'Link de indicação',
  1723: 'Obter mestres',
  1724: 'Mestres do Jogo',
  1725: 'Nesta seção você pode solicitar o recebimento dos Mestres do Jogo por meio de campanhas publicitárias globais. Para fazer uma solicitação, será necessário enviar um token especial 1GM para o seu endereço interno destinado ao recebimento de recursos. Para saber mais sobre o 1GM, entre em contato com os Formadores de Mercado de nível superior da sua estrutura.',
  1726: 'Ilimitada',
  1727: 'Válida para sempre',
  1728: 'Você tem uma assinatura ilimitada — não há mais nada para comprar.',
  1729: 'Obtenha seus próprios Mestres do Jogo por meio de uma campanha publicitária global',
  1730: 'Você pode solicitar para si o registro de',
  1731: 'Solicitar',
  1732: 'A possibilidade de solicitar o registro de Mestres do Jogo será ativada posteriormente.',
  1733: 'Amplie até o nível {{param1}} para mover os orbes',
  1734: '1GM é um token especial usado para solicitar o registro de Mestres do Jogo por meio de campanhas publicitárias globais. Para saber mais sobre o 1GM, entre em contato com os Formadores de Mercado de nível superior da sua estrutura.',
  1735: 'SUPORTE',
  1736: 'Novo ticket',
  1737: 'Assunto',
  1738: 'Mensagem',
  1739: 'Criar ticket',
  1740: 'Você ainda não tem tickets',
  1741: 'Voltar aos tickets',
  1742: 'Escreva uma resposta',
  1743: 'Responder',
  1744: 'Aberto',
  1745: 'Fechado',
  1746: 'Suporte',
  1747: 'Você',
  1748: 'Este ticket está fechado, você não pode mais responder.',
  1749: 'Cancelar',
  1750: 'Ainda não há mensagens neste ticket',
  1751: 'Respondido',
  1752: 'ORB',
  1753: 'R-ORB',
  1754: 'R-ORB MAP',
  1755: 'REEX MINER',
  1756: 'Item',
  1757: 'Esta seção está disponível apenas para formadores de mercado',
  1758: 'Acerte um drone e ganhe {{param1}} Loyalty coins. Cada tiro custa {{param2}} Loyalty coin.',
  1759: 'Cadastre-se para participar',
  1760: 'Recarregue seu saldo para continuar',
  1761: 'Recarregar',
  1762: 'Preço em outras moedas',
  1763: 'Para coletar é preciso acumular pelo menos {{param1}} REEX',
  1764: 'Pulso',
  1765: 'Pulso da loja',
  1766: 'O faturamento e tudo o que o explica. Esta tela responde à pergunta «por que estou pagando a assinatura».',
  1767: 'RECEITA, ÚLTIMO MÊS',
  1768: '{{param1}} vendas',
  1769: 'SUA POSIÇÃO',
  1770: 'de {{param1}} lojas no último mês',
  1771: 'sem vendas no último mês',
  1772: 'TERRAS VAZIAS',
  1773: 'terrenos dos seus mestres sem nenhum objeto',
  1776: 'CAPACIDADE',
  1777: 'tantos pacotes estão à venda agora',
  1785: 'Mestres com terras vazias',
  1787: 'A análise aparecerá quando o servidor começar a enviá-la',
  1790: 'Ainda não há dados',
  1793: '{{param1}} de {{param2}} terrenos vazios',
  1794: 'Todas as terras dos seus mestres estão construídas',
  1795: 'Ranking de vendas, último mês',
  1796: 'ranking anônimo de todas as lojas por vendas no período',
  1797: 'Sua loja',
  1798: 'Meus dados',
  1799: 'Ranking',
  1800: 'Pode colocar à venda: {{param1}}',
  1801: 'Máximo {{param1}} com os ativos atuais',
  1802: 'Ativos insuficientes para colocar mais à venda',
  1803: 'Loja',
  1804: 'Meus pedidos',
  1805: 'Pedidos',
  1806: 'Diga ao seu market maker do que precisa',
  1807: 'Novo pedido',
  1808: '{{param1}} de {{param2}} pedidos',
  1809: 'Ainda não há pedidos',
  1810: 'Pacotes: {{param1}}',
  1811: '{{param1}} Reex por pacote',
  1812: 'Total: {{param1}} Reex',
  1813: 'Escolha o que deseja comprar',
  1814: 'No pedido ({{param1}})',
  1815: 'Nada selecionado ainda',
  1816: 'Número de pacotes',
  1817: 'Preço por pacote (Reex)',
  1818: 'Criar pedido',
  1819: 'Pedidos dos seus mestres',
  1820: 'Seus mestres ainda não pediram nada',
  1821: 'Fechar pedido',
  1822: 'Limite atingido: exclua um pedido para criar um novo',
  1823: 'Não há recursos disponíveis para pedidos',
  1824: 'O que seus mestres querem comprar. Feche o pedido quando for atendido.',
  1825: 'O jogo está em beta inicial',
  1826: 'Legends of Interactions está em um estágio inicial de desenvolvimento. Funções e conteúdo ainda estão sendo adicionados e podem mudar de uma versão para outra.',
  1827: 'A versão atual do jogo está disponível no site oficial',
  1828: 'Baixar o jogo',
  1829: 'Códigos de convite para LOI',
  1830: 'ACUMULADO',
  1831: 'Clique no orbe para coletar',
  1832: 'Ainda não acumulou nada',
  1833: 'Extras',
  1834: 'Funções especiais do jogo',
  1835: 'Emuladores de jogadores',
  1836: 'Vincule um emulador a um conselheiro e ele coletará recursos por você.',
  1837: 'EMULADORES LIVRES',
  1838: 'Vincular emulador',
  1839: 'Ativo',
  1842: 'Não há emuladores livres',
  1843: 'Vincular um emulador ao conselheiro «{{param1}}»?',
  1844: 'O emulador começará a coletar recursos para este conselheiro.',
  1847: 'Você ainda não tem conselheiros',
  1848: 'Hexágonos: {{param1}} / {{param2}}',
  1851: 'Principal',
  1852: 'Ativo desde {{param1}}',
  1853: 'BATERIA',
  1854: 'Devolver ao inventário',
  1855: 'Devolver ao inventário o emulador do conselheiro «{{param1}}»?',
  1856: 'O emulador deixará de coletar recursos e ficará livre novamente.',
}

export default translation
